export default __webpack_public_path__ + "static/image-169-71d3364ecdea316556ac346801aaed7c.png";